import { render, staticRenderFns } from "./QRScan.vue?vue&type=template&id=8aefc814&scoped=true&"
import script from "./QRScan.vue?vue&type=script&lang=js&"
export * from "./QRScan.vue?vue&type=script&lang=js&"
import style0 from "./QRScan.vue?vue&type=style&index=0&id=8aefc814&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aefc814",
  null
  
)

export default component.exports